import React from 'react';
import { useDeleteUtilitiesMutation } from '../../services/building';
import { Box, Button, Modal, Text } from '@ies-ds/react-ui';

const UtilitiesDelete = ({ id }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [deleteUtilities, { isError, isLoading, isSuccess }] = useDeleteUtilitiesMutation();

  return (
    <div>
      <Button size="xsmall" onClick={() => setIsOpen(true)}>
        Delete
      </Button>
      <Modal
        closeButton
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <Modal.Header>
          <Text weight={'medium'} size="large">
            Delete Utility
          </Text>
        </Modal.Header>
        <Modal.Content>
          <Text weight="medium">Are you sure you want to delete this Utility?</Text>
          <br />
          {/* <p>All floor and Utility data associated with the Utility will be permanently deleted as well!</p> */}
        </Modal.Content>

        <Modal.Footer>
          <Box gap={8}>
            <Button color="warning" onClick={() => deleteUtilities(id)}>
              Delete
            </Button>
            <Button onClick={() => setIsOpen(false)}>Close</Button>
          </Box>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UtilitiesDelete;
